import { Routes, Route } from 'react-router-dom'

import AddNotificationRecipient from 'pages/AddNotificationRecipient'
import EditNotificationRecipient from 'pages/EditNotificationRecipient'
import NotificationRecipients from 'pages/Notifications'

const NotificationRecipientsRouter = () => {
  return (
    <Routes>
      <Route path=":notificationRecipientId/edit" element={<EditNotificationRecipient />} />
      <Route path="new" element={<AddNotificationRecipient />} />
      <Route index element={<NotificationRecipients />} />
    </Routes>
  )
}

export default NotificationRecipientsRouter
